import axios from "axios";

export const index = (filterRequestParams, callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.abstract_entities_path({ ... { ... filterRequestParams }, format: "json", _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const create = (currentEntityTypeId, formData, callback) => {
  let promise = axios({
    method: 'post',
    url: Routes.abstract_entities_path( currentEntityTypeId, { format: 'json' }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

export const update = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'patch',
    url: Routes.abstract_entity_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}
